<template>
  <div class="Ftim-box">
    <div class="Ftim-bt">
      <span>至德-</span>个人中心
      <i></i>
    </div>

    <div class="Current-box">
      <div class="Currbj-left"></div>

      <all-left></all-left>

      <div class="Current-right">
        <div class="">
          <div class="Current-topic">
            <div class="Current-name">至德经济</div>
            <div class="Current-want">
              <span
                :class="
                  releid == item.id ? 'Current-reletab on' : 'Current-reletab'
                "
                v-for="(item, index) in strinfo"
                :key="index"
                @click="releqie(item.id)"
                >{{ item.title }}</span
              >
              <div class="Ftim-fanhui" @click="Close()"></div>
            </div>
          </div>

          <div class="Current-cent">
            <!-- 简介 -->
            <div class="percon-box" v-if="isshow == 0">
              <div class="percon-intro">{{ infolist.company_intro }}</div>
              <div class="Current-introok" @click="Publish">编辑</div>
            </div>

            <!-- 简介编辑 -->
            <div class="" v-if="isshow == 1">
              <div class="reinfo-list">
                <i></i>
                <span>商城链接</span>
                <el-input
                  class="reinfo-inp"
                  type="text"
                  v-model="listcent.mall_url"
                  placeholder="请输入..."
                ></el-input>
              </div>

              <div class="reinfo-life">
                <div class="reinfo-uptop">
                  <i>*</i>
                  <span>logo</span>
                  <b>公司标识，png、jpg格式</b>
                </div>

                <div class="picture-box">
                  <div class="picture-up" v-if="!listcent.logo">
                    <el-upload
                      action=""
                      list-type="picture-card"
                      :before-upload="handlogo"
                      accept=".jpg, .jpeg, .png"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>

                  <div class="picture-ever">
                    <div class="picture-life" v-if="listcent.logo">
                      <img :src="listcent.logo" />
                      <span @click="dellogo()"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="reinfo-life">
                <div class="reinfo-uptop">
                  <i>*</i>
                  <span>缩略图</span>
                  <b>最多上传9张图片，第一张为缩略图</b>
                </div>

                <div class="picture-box">
                  <div class="picture-up" v-if="ruleForm.length < 9">
                    <el-upload
                      action=""
                      list-type="picture-card"
                      :before-upload="handleBeforeUpload"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>

                  <div class="picture-ever">
                    <div
                      class="picture-life"
                      v-for="(item, index) in ruleForm"
                      :key="index"
                    >
                      <img :src="item.url" />
                      <span @click="delpic(index)"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="reinfo-jianjie">
                <i>*</i>
                <span>企业简介</span>
                <el-input
                  class="reinfo-tare"
                  type="textarea"
                  :rows="10"
                  placeholder="请输入…"
                  v-model="listcent.intro"
                ></el-input>
              </div>

              <div class="reinfo-but">
                <div class="reinfo-close" @click="Preclose">取消</div>
                <div class="reinfo-ok" @click="Preserve">保存</div>
              </div>
            </div>

            <!-- 产品 -->
            <div class="product-box" v-if="isshow == 2">
              <div
                class="product-list"
                v-for="(item, index) in productinfo"
                :key="index"
              >
                <div class="product-pic">
                  <img :src="item.picture[0].url" />
                </div>
                <div class="product-title">{{ item.name }}</div>
                <div class="product-time">{{ item.updated_at }}</div>
                <div class="product-but">
                  <span
                    class="Current-bianji"
                    @click="Prodctadd(item, 2, index)"
                    >编辑</span
                  >
                  <span class="Current-shanchu" @click="Proddel(item.id, index)"
                    >删除</span
                  >
                </div>
              </div>

              <div class="Ftim-more" @click="Neimore" v-if="productgoto">
                加载更多
              </div>
            </div>

            <div
              class="product-add"
              v-if="isshow == 2"
              @click="Prodctadd('', 1, '')"
            >
              添加商品
            </div>

            <!-- 添加编辑产品弹框 -->
            <div class="examine-mark" v-if="prodtck"></div>
            <div class="operate-tck" v-if="prodtck">
              <div class="Current-sobox">
                <div class="product-name">{{ prodname }}</div>
                <div class="product-eve">
                  <span>商品名称</span>
                  <el-input
                    class="product-inp"
                    type="text"
                    v-model="adbjprodinfo.name"
                    placeholder="请输入商品名称"
                  ></el-input>
                </div>
                <div class="product-uppic">
                  <div class="reinfo-uptop">
                    <span>产品图</span>
                    <b>支持png、jpg格式</b>
                  </div>

                  <div class="product-upbox">
                    <div class="product-up" v-if="adbjprodinfo.picture < 1">
                      <el-upload
                        action=""
                        list-type="picture-card"
                        :before-upload="handproduct"
                        :on-success="successproduct"
                        accept=".jpg, .jpeg, .png"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>

                    <div class="picture-ever">
                      <div
                        class="picture-life"
                        v-for="(item, index) in adbjprodinfo.picture"
                        :key="index"
                      >
                        <img :src="item.url" />
                        <span @click="delprodpic(index)"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pbzd-but">
                  <div class="reinfo-close" @click="prodclose">取消</div>
                  <div class="reinfo-ok" @click="prodsav">保存</div>
                </div>
              </div>
            </div>

            <!-- 采购 -->
            <div class="purch-box" v-if="isshow == 3">
              <el-table
                :data="purchaseinfo"
                style="width: 100%"
                height="500"
                :header-cell-style="tableHeaderColor"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column
                  prop="goods_name"
                  label="采购产品"
                  align="center"
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="goods_spec"
                  label="采购规格"
                  align="center"
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="goods_num"
                  label="采购数量"
                  align="center"
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="updated_at"
                  label="发布时间"
                  align="center"
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作"
                  align="center"
                  header-align="center"
                  width="100"
                >
                  <template slot-scope="scope">
                    <img
                      src="../../../public/images/bianjbjt.png"
                      title="编辑信息"
                      class="czicon"
                      @click="Purchadd(scope.row, 2, scope.$index)"
                    />

                    <img
                      src="../../../public/images/shanchubjt.png"
                      title="删除"
                      class="czicon"
                      @click="Purchdel(scope.row.id, scope.$index)"
                    />
                  </template>
                </el-table-column>
              </el-table>

              <div class="Ftim-more" @click="purchmore" v-if="purchasegoto">
                加载更多
              </div>
            </div>

            <div
              class="product-add"
              v-if="isshow == 3"
              @click="Purchadd('', 1, '')"
            >
              发布采购
            </div>

            <!-- 添加编辑采购弹框 -->
            <div class="examine-mark" v-if="purchtck"></div>
            <div class="operate-tck" v-if="purchtck">
              <div class="Current-sobox">
                <div class="product-name">{{ purchname }}</div>
                <div class="product-eve">
                  <span>商品名称</span>
                  <el-input
                    class="product-inp"
                    type="text"
                    v-model="adbjpurchinfo.goods_name"
                    placeholder="请输入商品名称"
                  ></el-input>
                </div>
                <div class="product-eve">
                  <span>商品规格</span>
                  <el-input
                    class="product-inp"
                    type="text"
                    v-model="adbjpurchinfo.goods_spec"
                    placeholder="请输入商品规格"
                  ></el-input>
                </div>
                <div class="product-eve">
                  <span>适用单位</span>
                  <el-input
                    class="product-inp"
                    type="text"
                    v-model="adbjpurchinfo.unit"
                    placeholder="请输入单位"
                  ></el-input>
                </div>
                <div class="product-eve">
                  <span>采购数量</span>
                  <el-input
                    class="product-inp"
                    type="text"
                    v-model="adbjpurchinfo.goods_num"
                    placeholder="请输入采购数量"
                  ></el-input>
                </div>

                <div class="pbzd-but">
                  <div class="reinfo-close" @click="purchclose">取消</div>
                  <div class="reinfo-ok" @click="purchsav">保存</div>
                </div>
              </div>
            </div>

            <!-- 招标 -->
            <div class="purch-box" v-if="isshow == 4">
              <el-table
                :data="tendaseinfo"
                style="width: 100%"
                height="500"
                :header-cell-style="tableHeaderColor"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column
                  prop="name"
                  label="招标名称"
                  align="center"
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="start_time"
                  label="开始时间"
                  align="center"
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="end_time"
                  label="结束时间"
                  align="center"
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="updated_at"
                  label="发布时间"
                  align="center"
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作"
                  align="center"
                  header-align="center"
                  width="100"
                >
                  <template slot-scope="scope">
                    <img
                      src="../../../public/images/bianjbjt.png"
                      title="编辑信息"
                      class="czicon"
                      @click="tendadd(scope.row, 2, scope.$index)"
                    />

                    <img
                      src="../../../public/images/shanchubjt.png"
                      title="删除"
                      class="czicon"
                      @click="Tenddel(scope.row.id, scope.$index)"
                    />
                  </template>
                </el-table-column>
              </el-table>

              <div class="Ftim-more" @click="tendmore" v-if="tendasegoto">
                加载更多
              </div>
            </div>

            <div
              class="product-add"
              v-if="isshow == 4"
              @click="tendadd('', 1, '')"
            >
              发布招标
            </div>

            <!-- 添加编辑招标弹框 -->
            <div class="examine-mark" v-if="tendtck"></div>
            <div class="operate-tck" v-if="tendtck">
              <div class="Current-sobox">
                <div class="product-name">{{ tendname }}</div>
                <div class="product-eve">
                  <span>招标名称</span>
                  <el-input
                    class="product-inp"
                    type="text"
                    v-model="adbjtendinfo.name"
                    placeholder="请输入招标名称"
                  ></el-input>
                </div>
                <div class="product-eve">
                  <span>开始时间</span>
                  <el-date-picker
                    v-model="adbjtendinfo.start_time"
                    type="datetime"
                    placeholder="选择开始日期时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </div>
                <div class="product-eve">
                  <span>结束时间</span>
                  <el-date-picker
                    v-model="adbjtendinfo.end_time"
                    type="datetime"
                    placeholder="选择结束日期时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </div>

                <div class="pbzd-but">
                  <div class="reinfo-close" @click="tendclose">取消</div>
                  <div class="reinfo-ok" @click="tendsav">保存</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="Currbj-right"></div>
    </div>
  </div>
</template>
<script>
import AllLeft from "../../components/Personleft.vue"; //个人中心公用左侧
export default {
  components: {
    AllLeft,
  },
  data() {
    return {
      token: localStorage.pctoken, //获取token
      user: JSON.parse(localStorage.user),
      releid: 0, //切换
      strinfo: [
        //经济分类
        {
          title: "简介",
          id: 0,
        },
        {
          title: "产品",
          id: 1,
        },
        {
          title: "采购",
          id: 2,
        },
        {
          title: "招标",
          id: 3,
        },
      ],
      infolist: {}, //企业详情
      isshow: 0, //显示列表发布编辑
      listcent: {
        //简介编辑参数
        intro: "",
        picture: "",
        company_id: "",
        mall_url: "",
        logl: "",
      },
      ruleForm: [],
      productisdata: 0, //是否加载过产品数据 0未加载  1加载过
      productinfo: [], //产品数据
      productgoto: false, //产品列表加载更多
      productpage: 1, //产品列表页码
      prodtck: false, //产品弹框是否显示
      prodname: "", //产品弹框标题是编辑还是添加
      prodissavbj: "",
      adbjprodinfo: {
        //产品编辑还是添加数据
        name: "",
        picture: [],
      },
      prodindex: "", //编辑时获取的下标

      purchaseisdata: 0, //是否加载过采购数据 0未加载  1加载过
      purchaseinfo: [], //采购数据
      purchasegoto: false, //采购列表加载更多
      purchasepage: 1, //采购列表页码
      purchtck: false, //采购弹框是否显示
      purchname: "", //采购弹框标题是编辑还是添加
      purchissavbj: "",
      adbjpurchinfo: {
        //采购编辑还是添加数据
        goods_name: "",
        goods_spec: "",
        goods_num: "",
        unit: "",
      },
      purchindex: "", //采购编辑时获取的下标

      tendaseisdata: 0, //是否加载过招标数据 0未加载  1加载过
      tendaseinfo: [], //招标数据
      tendasegoto: false, //招标列表加载更多
      tendasepage: 1, //招标列表页码
      tendtck: false, //招标弹框是否显示
      tendname: "", //招标弹框标题是编辑还是添加
      tendissavbj: "",
      adbjtendinfo: {
        //招标编辑还是添加数据
        name: "",
        start_time: "",
        end_time: "",
      },
      tendindex: "", //招标编辑时获取的下标
    };
  },
  created() {
    this.$layer.loading();
    if (!localStorage.user) {
      this.$confirm("请登录后查看，是否登录", "提示", {
        confirmButtonText: "登录",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ name: "login" });
        })
        .catch(() => {
          this.$router.push({ name: "Index" });
        });
    } else if (
      JSON.parse(localStorage.user).company_id == null ||
      JSON.parse(localStorage.user).company_id == 0
    ) {
      this.$confirm("请认证后查看，是否去认证", "提示", {
        confirmButtonText: "认证",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ name: "Agreement" });
        })
        .catch(() => {
          this.$router.go(-1);
        });
    } else if (
      JSON.parse(localStorage.user).company_id != null ||
      JSON.parse(localStorage.user).company_id != 0
    ) {
      this.$http
        .post(
          "/check/company_status",
          {
            company_id: JSON.parse(localStorage.user).company_id,
          },
          {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          }
        )
        .then((response) => {
          this.$layer.closeAll("loading");
          if (response.data.code == 200) {
            if (response.data.data == 1) {
              this.$layer.msg("正在审核中，请稍后查看");
              setTimeout(() => {
                this.$router.go(-1);
              }, 1800);
            } else if (response.data.data == 2) {
              this.$confirm("认证未通过，是否重新认证", "提示", {
                confirmButtonText: "认证",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.$router.push({ name: "Agreement" });
                })
                .catch(() => {
                  this.$router.go(-1);
                });
            } else {
              this.getData();
            }
          }
        });
    }
  },
  mounted() {},
  methods: {
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #F2F2F2; color: #999;font-weight: bold; font-size: 16px; text-align:left";
      }
    },

    //获取详情数据
    getData() {
      this.$layer.loading();
      this.$http
        .get("company/" + this.user.company_id, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.$layer.closeAll("loading");
          if (res.data.code == 200) {
            this.infolist = res.data.data;
          } else {
            this.$layer.msg(res.data.message);
          }
        });
    },

    //切换
    releqie(id) {
      this.releid = id;
      if (id == 0) {
        this.isshow = 0;
      } else if (id == 1) {
        if (this.productisdata == 0) {
          this.getproduct();
        }
        this.isshow = 2;
      } else if (id == 2) {
        if (this.purchaseisdata == 0) {
          this.getpurchase();
        }
        this.isshow = 3;
      } else if (id == 3) {
        if (this.tendaseisdata == 0) {
          this.gettendase();
        }
        this.isshow = 4;
      }
    },

    //经济简介编辑
    Publish() {
      this.isshow = 1;
      this.listcent = {
        intro: this.infolist.company_intro,
        picture: JSON.parse(this.infolist.company_album),
        company_id: this.infolist.id,
        mall_url: "",
        logo: this.infolist.logo,
      };
      if (JSON.parse(this.infolist.company_album) == null) {
        this.ruleForm = [];
      } else {
        this.ruleForm = JSON.parse(this.infolist.company_album);
      }
    },

    //上传logo
    handlogo(file) {
      const formData = new FormData();
      formData.append("img", file);
      this.uploadlogo(formData);
      return false;
    },
    uploadlogo(formData) {
      this.$layer.loading();
      this.$http
        .post("upload", formData, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.$layer.closeAll("loading");
            this.listcent.logo = response.data.data.path;
          } else {
            this.$layer.closeAll("loading");
          }
        });
    },

    //删除logo
    dellogo() {
      this.listcent.logo = "";
    },

    //上传缩略图
    handleBeforeUpload(file) {
      const formData = new FormData();
      formData.append("img", file);
      this.uploadObject(formData);
      return false;
    },
    uploadObject(formData) {
      this.$layer.loading();
      this.$http
        .post("upload", formData, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.$layer.closeAll("loading");
            this.ruleForm.push({ url: response.data.data.path });
          } else {
            this.$layer.closeAll("loading");
          }
        });
    },

    //删除缩略图
    delpic(index) {
      this.ruleForm.splice(index, 1);
    },

    //经济简介编辑取消
    Preclose() {
      this.isshow = 0;
      this.listcent = {
        intro: this.infolist.company_intro,
        picture: JSON.parse(this.infolist.company_album),
        company_id: this.infolist.id,
        mall_url: "",
        logo: this.infolist.logo,
      };
      this.ruleForm = JSON.parse(this.infolist.company_album);
    },

    //经济简介编辑保存
    Preserve() {
      this.$layer.loading();
      this.listcent.picture = this.ruleForm;
      this.$http
        .post("complete/company/info", this.listcent, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.$layer.closeAll("loading");
          if (res.data.code == 200) {
            this.$layer.msg("已提交审核");
            setTimeout(() => {
              this.isshow = 0;
              this.getData();
              window.scrollTo({
                top: 300,
                behavior: "smooth", // 平滑滚动
              });
            }, 800);
          } else {
            this.$layer.msg(res.data.message);
          }
        });
    },

    //获取产品列表
    getproduct() {
      this.$layer.loading();
      this.$http
        .get(
          "get/product?company_id=" +
            this.user.company_id +
            "&page=" +
            this.productpage,
          {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$layer.closeAll("loading");
            (this.productisdata = 1),
              (this.productinfo = this.productinfo.concat(res.data.data.data));
            if (res.data.data.next_page_url != null) {
              this.productgoto = true;
              this.productpage += 1;
            } else {
              this.productgoto = false;
            }
          } else {
            this.$layer.msg(res.data.message);
          }
        });
    },

    //添加编辑产品
    Prodctadd(info, num, index) {
      if (num == 1) {
        this.prodissavbj = 1;
        this.prodname = "添加商品";
      } else if (num == 2) {
        this.prodissavbj = 2;
        this.prodname = "编辑商品";
        this.prodindex = index;
        (this.adbjprodinfo = {
          name: info.name,
          picture: info.picture,
        }),
          (this.adbjprodinfo.id = info.id);
      }
      this.prodtck = true;
    },

    //商品图上传
    handproduct(file) {
      const formData = new FormData();
      formData.append("img", file);
      this.uploadproduct(formData);
      return false;
    },
    uploadproduct(formData) {
      this.$layer.loading();
      this.$http
        .post("upload", formData, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then(this.successproduct)
        .catch(this.handleError);
    },
    successproduct(response) {
      this.$layer.closeAll("loading");
      this.adbjprodinfo.picture.push({ url: response.data.data.path });
    },

    //删除商品图
    delprodpic() {
      this.adbjprodinfo.picture = [];
    },

    //加载更多产品
    prodmore() {
      this.getproduct();
    },

    //提交创建或编辑
    prodsav() {
      if (!this.adbjprodinfo.name) {
        this.$layer.msg("请填写商品名称");
        return;
      }

      if (this.adbjprodinfo.picture.length == 0) {
        this.$layer.msg("请上传商品图");
        return;
      }

      if (this.prodissavbj == 1) {
        this.$layer.loading();
        this.adbjprodinfo.company_id = this.user.company_id;
        this.$http
          .post("create/product", this.adbjprodinfo, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg("已提交审核");
              setTimeout(() => {
                this.prodtck = false;
                this.adbjprodinfo = {
                  name: "",
                  picture: [],
                };
                this.prodissavbj = "";
              }, 800);
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      } else if (this.prodissavbj == 2) {
        this.$layer.loading();
        this.$http
          .put("product", this.adbjprodinfo, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg("编辑成功");
              setTimeout(() => {
                this.prodtck = false;
                this.productinfo[this.prodindex].picture =
                  this.adbjprodinfo.picture;
                this.productinfo[this.prodindex].name = this.adbjprodinfo.name;
                this.adbjprodinfo = {
                  name: "",
                  picture: [],
                };
                this.prodissavbj = "";
              }, 800);
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      }
    },

    //取消创建或编辑
    prodclose() {
      this.prodtck = false;
      this.adbjprodinfo = {
        name: "",
        picture: [],
      };
      this.prodissavbj = "";
    },

    //删除产品
    Proddel(id, index) {
      this.$confirm("是否删除该产品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$layer.loading();
        this.$http
          .delete("product?id=" + id, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg("删除成功");
              this.productinfo.splice(index, 1);
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      });
    },

    //获取采购列表
    getpurchase() {
      this.$layer.loading();
      this.$http
        .get(
          "get/goods?company_id=" +
            this.user.company_id +
            "&page=" +
            this.purchasepage,
          {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$layer.closeAll("loading");
            (this.purchaseisdata = 1),
              (this.purchaseinfo = this.purchaseinfo.concat(
                res.data.data.data
              ));
            if (res.data.data.next_page_url != null) {
              this.purchasegoto = true;
              this.purchasepage += 1;
            } else {
              this.purchasegoto = false;
            }
          } else {
            this.$layer.msg(res.data.message);
          }
        });
    },

    //添加编辑采购
    Purchadd(info, num, index) {
      if (num == 1) {
        this.purchissavbj = 1;
        this.purchname = "发布采购信息";
      } else if (num == 2) {
        this.purchissavbj = 2;
        this.purchname = "编辑采购信息";
        this.purchindex = index;
        (this.adbjpurchinfo = {
          goods_name: info.goods_name,
          goods_spec: info.goods_spec,
          goods_num: info.goods_num,
          unit: info.unit,
        }),
          (this.adbjpurchinfo.id = info.id);
      }
      this.purchtck = true;
    },

    //提交创建或编辑采购
    purchsav() {
      if (!this.adbjpurchinfo.goods_name) {
        this.$layer.msg("请填写商品名称");
        return;
      }

      if (!this.adbjpurchinfo.goods_spec) {
        this.$layer.msg("请填写商品规格");
        return;
      }

      if (!this.adbjpurchinfo.unit) {
        this.$layer.msg("请填写适用单位");
        return;
      }

      if (!this.adbjpurchinfo.goods_num) {
        this.$layer.msg("请填写采购数量");
        return;
      }

      if (this.purchissavbj == 1) {
        this.$layer.loading();
        this.adbjpurchinfo.company_id = this.user.company_id;
        this.$http
          .post("create/goods", this.adbjpurchinfo, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg("已提交审核");
              setTimeout(() => {
                this.purchtck = false;
                (this.adbjpurchinfo = {
                  goods_name: "",
                  goods_spec: "",
                  goods_num: "",
                  unit: "",
                }),
                  (this.purchissavbj = "");
              }, 800);
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      } else if (this.purchissavbj == 2) {
        this.adbjpurchinfo.company_id = this.user.company_id;
        this.adbjpurchinfo.user_id = this.user.user.id;
        this.$layer.loading();
        this.$http
          .put("edit/goods/" + this.adbjpurchinfo.id, this.adbjpurchinfo, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg("编辑成功");
              setTimeout(() => {
                this.purchtck = false;
                this.purchaseinfo[this.purchindex].goods_name =
                  this.adbjpurchinfo.goods_name;
                this.purchaseinfo[this.purchindex].goods_spec =
                  this.adbjpurchinfo.goods_spec;
                this.purchaseinfo[this.purchindex].goods_num =
                  this.adbjpurchinfo.goods_num;
                (this.adbjpurchinfo = {
                  goods_name: "",
                  goods_spec: "",
                  goods_num: "",
                  unit: "",
                }),
                  (this.purchissavbj = "");
              }, 800);
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      }
    },

    //加载更多采购
    purchmore() {
      this.getpurchase();
    },

    //取消创建或编辑采购
    purchclose() {
      this.purchtck = false;
      (this.adbjpurchinfo = {
        goods_name: "",
        goods_spec: "",
        goods_num: "",
        unit: "",
      }),
        (this.purchissavbj = "");
    },

    //删除采购
    Purchdel(id, index) {
      this.$confirm("是否删除该采购信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$layer.loading();
        this.$http
          .delete("goods/" + id, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg("删除成功");
              this.purchaseinfo.splice(index, 1);
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      });
    },

    //获取招标列表
    gettendase() {
      this.$layer.loading();
      this.$http
        .get(
          "get/engineering?company_id=" +
            this.user.company_id +
            "&page=" +
            this.tendasepage,
          {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$layer.closeAll("loading");
            (this.tendaseisdata = 1),
              (this.tendaseinfo = this.tendaseinfo.concat(res.data.data.data));
            if (res.data.data.next_page_url != null) {
              this.tendasegoto = true;
              this.tendasepage += 1;
            } else {
              this.tendasegoto = false;
            }
          } else {
            this.$layer.msg(res.data.message);
          }
        });
    },

    //添加编辑招标
    tendadd(info, num, index) {
      if (num == 1) {
        this.tendissavbj = 1;
        this.tendname = "发布招标信息";
      } else if (num == 2) {
        this.tendissavbj = 2;
        this.tendname = "编辑招标信息";
        this.tendindex = index;
        (this.adbjtendinfo = {
          name: info.name,
          start_time: info.start_time,
          end_time: info.end_time,
        }),
          (this.adbjtendinfo.id = info.id);
      }
      this.tendtck = true;
    },

    //提交创建或编辑招标
    tendsav() {
      if (!this.adbjtendinfo.name) {
        this.$layer.msg("请填写招标名称");
        return;
      }

      if (!this.adbjtendinfo.start_time) {
        this.$layer.msg("请填写开始时间");
        return;
      }

      if (!this.adbjtendinfo.end_time) {
        this.$layer.msg("请填写结束时间");
        return;
      }

      if (this.tendissavbj == 1) {
        this.$layer.loading();
        this.adbjtendinfo.company_id = this.user.company_id;
        this.$http
          .post("create/engineering", this.adbjtendinfo, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg("已提交审核");
              setTimeout(() => {
                this.tendtck = false;
                (this.adbjtendinfo = {
                  name: "",
                  start_time: "",
                  end_time: "",
                }),
                  (this.tendissavbj = "");
              }, 800);
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      } else if (this.tendissavbj == 2) {
        this.adbjtendinfo.company_id = this.user.company_id;
        this.$layer.loading();
        this.$http
          .put("engineering/" + this.adbjtendinfo.id, this.adbjtendinfo, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg("编辑成功");
              setTimeout(() => {
                this.tendtck = false;
                this.tendaseinfo[this.tendindex].name = this.adbjtendinfo.name;
                this.tendaseinfo[this.tendindex].start_time =
                  this.adbjtendinfo.start_time;
                this.tendaseinfo[this.tendindex].end_time =
                  this.adbjtendinfo.end_time;
                (this.adbjtendinfo = {
                  name: "",
                  start_time: "",
                  end_time: "",
                }),
                  (this.tendissavbj = "");
              }, 800);
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      }
    },

    //招标加载更多
    tendmore() {
      this.gettendase();
    },

    //取消创建或编辑招标
    tendclose() {
      this.tendtck = false;
      (this.adbjtendinfo = {
        name: "",
        start_time: "",
        end_time: "",
      }),
        (this.tendissavbj = "");
    },

    //删除招标
    Tenddel(id, index) {
      this.$confirm("是否删除该招标信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$layer.loading();
        this.$http
          .delete("engineering/" + id, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg("删除成功");
              this.tendaseinfo.splice(index, 1);
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      });
    },
  },
};
</script>
<style scoped>
.Ftim-box {
  background: url(../../../public/images/dysjbjt.png) top no-repeat;
  margin-bottom: 20px;
}
.Ftim-bt {
  width: 1200px;
  margin: 72px auto 0;
  font-weight: bold;
  font-size: 48px;
  color: #333;
  line-height: 48px;
}
.Ftim-bt span {
  color: #d71e1c;
}
.Ftim-bt i {
  display: block;
  width: 48px;
  height: 4px;
  background: #d71e1c;
  margin-top: 30px;
}
.Current-box {
  width: 1200px;
  margin: 80px auto 0;
  display: flex;
}
.Currbj-left {
  width: 30px;
  height: 790px;
  background: url(../../../public/images/grleft.png) bottom no-repeat;
}
.Currbj-right {
  width: 30px;
  height: 790px;
  background: url(../../../public/images/grright.png) bottom no-repeat;
}
.Current-right {
  flex: 1;
  background: #fff;
  border-left: 1px solid #d8d8d8;
  padding: 40px 0 0 40px;
  border-radius: 0 20px 0 0;
}
.Current-cent {
  width: 95%;
  height: 620px;
}
.Current-cent::-webkit-scrollbar {
  width: 2px;
  height: 4px;
  margin-top: 10px;
}

.Current-cent::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.Current-cent::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.percon-box {
  height: 100%;
}
.percon-intro {
  height: 86%;
  overflow: auto;
  font-size: 16px;
  color: #333333;
  line-height: 32px;
  margin-top: 30px;
  padding-right: 10px;
}
.percon-intro::-webkit-scrollbar {
  width: 2px;
  height: 4px;
  margin-top: 10px;
}

.percon-intro::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.percon-intro::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.product-box {
  max-height: 570px;
  overflow: auto;
  padding-right: 20px;
}
.product-box::-webkit-scrollbar {
  width: 2px;
  height: 4px;
  margin-top: 10px;
}

.product-box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.product-box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.purch-box {
  max-height: 570px;
  overflow: auto;
  padding-right: 6px;
  margin-top: 20px;
}
.purch-box::-webkit-scrollbar {
  width: 2px;
  height: 4px;
  margin-top: 10px;
}

.purch-box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.purch-box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.Current-topic {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #d8d8d8;
  margin-right: 40px;
}
.Current-name {
  font-weight: bold;
  font-size: 24px;
  color: #333333;
}
.Current-want {
  display: flex;
  align-items: center;
}
.Current-unread {
  width: 80px;
  height: 28px;
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%);
  border-radius: 14px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
.Current-list {
  display: flex;
  width: 760px;
  border-bottom: 1px solid #d8d8d8;
  margin-top: 20px;
  padding: 20px;
}
.Current-pic {
  width: 84px;
  height: 84px;
  border-radius: 8px;
}
.Current-pic img {
  width: 84px;
  height: 84px;
  border-radius: 8px;
}
.Current-info {
  flex: 1;
  margin-left: 20px;
}
.Current-fist {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Current-fistleft {
  display: flex;
  align-items: center;
}
.Current-leib {
  font-size: 12px;
  color: #ffffff;
  padding: 2px 10px;
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%);
  border-radius: 9px;
}
.Current-title {
  font-size: 16px;
  color: #333333;
  overflow: hidden; /* 溢出部分进行隐藏 */
  display: -webkit-box;
  -webkit-box-orient: vertical; /* 盒模型元素从顶部向底部垂直排列子元素 */
  -webkit-line-clamp: 1; /* 显示两行 */
  text-overflow: ellipsis;
  margin-left: 10px;
}
.Current-star {
  font-size: 16px;
  color: #999999;
}
.Current-time {
  font-size: 16px;
  color: #999999;
  margin-top: 10px;
}
.Current-time span {
  margin-right: 15px;
}
.Current-bot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}
.Current-count {
  font-size: 16px;
  color: #999999;
}
.Current-xf {
  background: linear-gradient(137deg, #ffb73a 0%, #fe6809 100%), #f2f2f2;
  border-radius: 12px;
  line-height: 24px;
  text-align: center;
  padding: 4px 18px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  margin-right: 16px;
}
.Current-gl {
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%), #f2f2f2;
  border-radius: 12px;
  line-height: 24px;
  text-align: center;
  padding: 4px 18px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}
.Current-fab {
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%), #f2f2f2;
  border-radius: 12px;
  line-height: 24px;
  text-align: center;
  padding: 4px 18px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}
.Ftim-more {
  width: 180px;
  height: 36px;
  background: #f2f2f2;
  border-radius: 18px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 36px;
  text-align: center;
  margin: 40px auto 0;
  cursor: pointer;
}
.reinfo-list {
  display: flex;
  border-bottom: 1px dotted #d8d8d8;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 16px;
}
.reinfo-list i {
  width: 6px;
  color: #e2195c;
}
.reinfo-list span {
  width: 110px;
  font-size: 16px;
  color: #333;
  margin-left: 2px;
}
.reinfo-inp {
  width: 90%;
}
::v-deep .reinfo-list .reinfo-inp .el-input__inner {
  width: 90%;
  font-size: 16px;
  font-family: ArialMT;
  color: #666666;
  border: none;
  padding: 0;
}
::v-deep .reinfo-list .el-input--suffix .el-input__inner {
  border: none;
  background: #f2f2f2;
  border-radius: 16px;
}

.reinfo-uppic {
  border-bottom: 1px dotted #d8d8d8;
  margin-top: 20px;
  padding-bottom: 16px;
}
::v-deep .reinfo-uppic .el-upload--picture-card {
  width: 72px;
  height: 90px !important;
  line-height: 100px !important;
}
.reinfo-uptop {
  display: flex;
  align-items: center;
}
.reinfo-uptop i {
  width: 6px;
  color: #e2195c;
}
.reinfo-uptop span {
  width: 110px;
  font-size: 16px;
  color: #333;
  margin-left: 2px;
}
.reinfo-uptop b {
  font-size: 16px;
  color: #d8d8d8;
  font-weight: 400;
}
.picture-box {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-left: 120px;
}
.picture-up {
  margin-right: 20px;
}
.picture-ever {
  display: flex;
  align-items: center;
}
.picture-list {
  position: relative;
  margin-right: 20px;
}
.picture-list img {
  width: 72px;
  height: 90px;
  border-radius: 6px;
}
.picture-list span {
  display: block;
  position: absolute;
  top: -8px;
  right: -9px;
  width: 18px;
  height: 18px;
  background: url(../../../public/images/gb.png) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.reinfo-but {
  display: flex;
  width: 440px;
  margin: 10px 0 0 120px;
}
.pbzd-but {
  display: flex;
  width: 440px;
  margin: 10px 0 0 10px;
}
.reinfo-close {
  width: 200px;
  height: 36px;
  background: #d8d8d8;
  border-radius: 18px;
  font-size: 18px;
  color: #333333;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}
.reinfo-ok {
  width: 200px;
  height: 36px;
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%), #d8d8d8;
  border-radius: 18px;
  font-size: 18px;
  color: #fff;
  line-height: 36px;
  margin-left: 20px;
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
}
.bordnone {
  border-bottom: none;
}
.reinfo-styl {
  border-bottom: 1px dotted #d8d8d8;
  margin-top: 20px;
  padding-bottom: 16px;
}
.reinfo-styl i {
  width: 6px;
  color: #e2195c;
}
.reinfo-styl span {
  width: 110px;
  font-size: 16px;
  color: #333;
  margin-left: 2px;
}
.memorside {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.memorlist {
  position: relative;
  width: 190px;
  height: 190px;
  margin-right: 20px;
  margin-top: 16px;
  cursor: pointer;
}
.memorside img {
  display: block;
  width: 190px;
  height: 190px;
  border-radius: 12px;
}

.memorlist span {
  display: block;
  width: 190px;
  height: 190px;
  border-radius: 12px;
  position: absolute;
  top: 0;
  left: -2px;
  background: url(../../../public/images/tangxz.png) 50% 50% no-repeat
    rgba(255, 255, 255, 0.6);
  background-size: 40px 40px;
}
.Ftim-fanhui {
  width: 20px;
  height: 20px;
  margin-right: 16px;
  margin-left: 10px;
  background: url(../../../public/images/fanhui.png) right center no-repeat;
  background-size: 20px 20px;
  cursor: pointer;
}
.Current-reletab {
  display: inline-block;
  width: 64px;
  height: 28px;
  background: #f2f2f2;
  border-radius: 14px;
  margin-right: 16px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
.Current-reletab.on {
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%), #f2f2f2;
  color: #fff;
}
.Current-reletext {
  width: 95%;
  border: 1px solid #d8d8d8;
  margin-top: 30px;
}
::v-deep .Agree-info .el-textarea__inner {
  padding: 10px 15px;
  font-size: 16px;
  border: none;
  resize: none;
}
.Current-introok {
  width: 200px;
  height: 36px;
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%), #d8d8d8;
  border-radius: 18px;
  font-size: 18px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  margin: 40px auto 0;
  cursor: pointer;
}
.reinfo-jianjie {
  display: flex;
  border-bottom: 1px dotted #d8d8d8;
  margin-top: 20px;
  padding-bottom: 16px;
}

.reinfo-jianjie i {
  width: 6px;
  color: #e2195c;
}
.reinfo-jianjie span {
  width: 116px;
  display: block;
  font-size: 16px;
  color: #333;
  margin-left: 2px;
}
.reinfo-tare {
  width: 90%;
}
::v-deep .reinfo-tare .el-textarea__inner {
  width: 100%;
  border: none;
  font-size: 16px;
  padding: 0;
  resize: none;
}
.reinfo-life {
  border-bottom: 1px dotted #d8d8d8;
  margin-top: 20px;
  padding-bottom: 16px;
}
::v-deep .reinfo-life .el-upload--picture-card {
  width: 72px;
  height: 72px !important;
  line-height: 79px !important;
}

.Current-bianji {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  padding-left: 20px;
  background: url(../../../public/images/bianjbjt.png) left no-repeat;
  background-size: 16px 17px;
  line-height: 26px;
  cursor: pointer;
}
.Current-shanchu {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  padding-left: 20px;
  background: url(../../../public/images/shanchubjt.png) left no-repeat;
  background-size: 16px 17px;
  line-height: 26px;
  cursor: pointer;
  margin-left: 20px;
}
.Current-lifepic {
  width: 165px;
  height: 120px;
  border-radius: 8px;
}
.Current-lifepic img {
  width: 165px;
  height: 120px;
  border-radius: 8px;
}
.Current-lifetitle {
  font-size: 16px;
  color: #333333;
  height: 84px;
}
.product-list {
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #d8d8d8;
}
.product-pic {
  width: 84px;
  height: 84px;
  border-radius: 6px;
}
.product-pic img {
  width: 84px;
  height: 84px;
  border-radius: 6px;
}
.product-title {
  font-size: 16px;
  color: #333333;
  line-height: 26px;
  margin-left: 15px;
  flex: 1;
}
.product-time {
  font-size: 16px;
  color: #999999;
  margin-left: 62px;
}
.product-but {
  margin-left: 140px;
}

.product-add {
  width: 200px;
  height: 36px;
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%), #d8d8d8;
  border-radius: 18px;
  font-size: 18px;
  color: #fff;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 20px;
}
.examine-mark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 3;
}
.operate-tck {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
.Current-sobox {
  padding: 30px 40px;
  background: #ffffff;
  border-radius: 12px;
}
.product-name {
  font-weight: bold;
  font-size: 24px;
  color: #333333;
}

.product-eve {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 16px;
}
.product-eve span {
  width: 110px;
  font-size: 16px;
  color: #333;
  margin-left: 2px;
}
::v-deep .product-eve .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 331px;
  margin-left: -15px;
}
.product-uppic {
  margin-top: 20px;
  padding-bottom: 16px;
}
.product-uppic span {
  width: 100px;
  font-size: 16px;
  color: #333;
  margin-left: 2px;
}
.product-inp {
  width: 90%;
}
::v-deep .product-eve .product-inp .el-input__inner {
  width: 330px;
  font-size: 16px;
  background: #f2f2f2;
  border-radius: 16px;
  color: #666666;
  border: none;
  padding: 0 10px;
}
::v-deep .product-eve .el-input--suffix .el-input__inner {
  border: none;
  background: #f2f2f2;
  border-radius: 16px;
}
.product-upbox {
  display: flex;
  align-items: center;
  margin-left: 106px;
  margin-top: 30px;
}
.product-up {
  padding-bottom: 16px;
}
::v-deep .product-up .el-upload--picture-card {
  width: 72px;
  height: 72px !important;
  line-height: 79px !important;
}

.Current-sobut {
  width: 200px;
  height: 36px;
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%), #d8d8d8;
  border-radius: 18px;
  font-size: 18px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  margin: 26px auto 0;
  cursor: pointer;
}
.picture-life {
  position: relative;
  margin-right: 20px;
}
.picture-life img {
  width: 72px;
  height: 72px;
  border-radius: 6px;
}
.picture-life span {
  display: block;
  position: absolute;
  top: -8px;
  right: -9px;
  width: 18px;
  height: 18px;
  background: url(../../../public/images/gb.png) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.czicon {
  margin-right: 16px;
  cursor: pointer;
  width: 14px;
  height: 14px;
}
</style>